import React from 'react';
import { Link } from 'react-router-dom';

const plans = [
  {
    name: 'Normal User',
    price: '₹1000/month',
    benefits: [
      'Access to verified friends',
      'View profiles',
      'Send requests',
      'Chat & call',
    ],
    cta: 'Join as User',
    to: '/register?role=user',
    primary: true,
  },
  {
    name: 'Service Provider',
    price: '₹5000/month',
    benefits: [
      'Create profile',
      'Receive requests',
      'Earn per chat/call',
    ],
    cta: 'Become a Friend',
    to: '/register?role=provider',
    primary: false,
  },
];

const PricingSection = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center mb-12">
          Membership Plans
        </h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`rounded-2xl border-2 p-8 bg-slate-800/80 ${
                plan.primary ? 'border-brand-pink' : 'border-slate-600'
              }`}
            >
              <h3 className="font-heading font-bold text-xl text-white">{plan.name}</h3>
              <p className="mt-2 text-2xl font-semibold text-brand-pink">{plan.price}</p>
              <ul className="mt-6 space-y-2">
                {plan.benefits.map((b, i) => (
                  <li key={i} className="text-slate-400">
                    {b}
                  </li>
                ))}
              </ul>
              <Link
                to={plan.to}
                className={`mt-8 block w-full py-3 rounded-xl text-center font-semibold transition-colors ${
                  plan.primary
                    ? 'bg-brand-pink text-white hover:bg-brand-pink-dark'
                    : 'bg-slate-700 text-white hover:bg-slate-600'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
